import markItemReadInReadingPaneStore from '../actions/markItemReadInReadingPaneStore';
import markItemsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsReadStoreUpdate';
import { orchestrator } from 'satcheljs';
export default orchestrator(markItemsAsReadStoreUpdate, function (actionMessage) {
    var itemIds = actionMessage.itemIds, isReadValue = actionMessage.isReadValue;
    itemIds.forEach(function (itemId) { return markItemReadInReadingPaneStore(itemId, isReadValue); });
});
//# sourceMappingURL=markItemsAsReadStoreUpdateOrchestrator.js.map